import type { ColumnDef, RowData } from '@tanstack/react-table';

// Extend TanStack Table's ColumnMeta via declaration merging
declare module '@tanstack/react-table' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface ColumnMeta<TData extends RowData, TValue> {
    searchable?: boolean;
    hasSearchIcon?: boolean;
    headerTooltip?: string;
    columnGroupId?: string;
    align?: 'left' | 'right' | 'center';
  }
}

/**
 * Get the column identifier (accessorKey or id) from a ColumnDef.
 * accessorKey only exists on AccessorKeyColumnDef variant of the union,
 * so we use a type-safe helper instead of casting everywhere.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getColumnId<TData extends RowData>(col: ColumnDef<TData, any>): string {
  return (col as { accessorKey?: string }).accessorKey || col.id || '';
}

export type { ColumnDef };
